import React, { useState, useEffect, useCallback } from 'react';
import useColumnResize from '../../hooks/useColumnResize';
import useTablePagination from '../../hooks/useTablePagination';
import ReadyFilters, { useReadyFilters } from '../../components/ReadyFilters';

const toFa = n => n===null||n===undefined?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);
const toEng = s => String(s).replace(/[۰-۹]/g,d=>'۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
const numFmt = n => { const v=Math.abs(n||0); return v ? v.toLocaleString('fa-IR') : '•'; };
const si = v => { try{return parseInt(toEng(String(v||0)),10)||0;}catch{return 0;} };

/* فراخوانی API + رفرش توکن */
async function API(path,opts={}){
  const doFetch=()=>fetch(`/api/accounting${path}`,{headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('access')}`},...opts});
  let res=await doFetch();
  if(res.status===401){const rr=await fetch('/api/auth/token/refresh/',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({refresh:localStorage.getItem('refresh')})});if(rr.ok){const d=await rr.json();localStorage.setItem('access',d.access);res=await doFetch();}}
  return res.json();
}

/* تامین اعتبار */
export default function HavalehReadyModal({ year, onClose, onAdded }) {
  const [rawRows,  setRawRows]  = useState([]);
  const [selected, setSelected] = useState(null);
  const [readyNo,  setReadyNo]  = useState('');
  // فیلترهای همزمان: جستجو + هزینه‌ای/تملک + سال مالی (سمت سرور)
  const f = useReadyFilters({ initialFy: year });
  const [serverTotal,   setServerTotal]   = useState(0);
  const [serverHasMore, setServerHasMore] = useState(false);
  const [loadingMore,   setLoadingMore]   = useState(false);
  const [currentPage,   setCurrentPage]   = useState(1);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');
  const [problems, setProblems] = useState([]);
  // هشدارها (severity=warning) فقط نمایش داده می‌شوند و جلوی ساخت سند را نمی‌گیرند
  const blockers = problems.filter(p => p.severity !== 'warning');
  const [checking, setChecking] = useState(false);
  const [saving,   setSaving]   = useState(false);
  const [splitMode, setSplitMode] = useState(0);
  const [toast,    setToast]    = useState('');

  const [detRows,        setDetRows]        = useState([]);
  const [detTotal,       setDetTotal]       = useState(0);
  const [detHasMore,     setDetHasMore]     = useState(false);
  const [detPage,        setDetPage]        = useState(1);
  const [detLoading,     setDetLoading]     = useState(false);
  const [detLoadingMore, setDetLoadingMore] = useState(false);

  /* عرض ستون‌ها */
  const { TH }      = useColumnResize([55,70,80,75,80,70,150,190,150,150,110,100,100,95,100,100,110,95,50]);
  /* عرض ستون‌ها */
  const { TH: DTH } = useColumnResize([180,140,120,170,160,150,140,110,100,100,95,105,105,110,100,110,95,130,80]);

  const {
    visibleRows,
    shownCount, LoadMoreButton,
  } = useTablePagination({
    allRows: rawRows, pageSize: 200,
    searchFields: [],   // جستجو سمت سرور انجام می‌شود
    serverTotal, serverHasMore,
  });

  const qs = useCallback((page) => {
    const p = [`page=${page}`];
    if (f.query) p.push(f.query);
    return p.join('&');
  }, [f.query]);

  /* خواندن فهرست از سرور */
  const load = useCallback(async () => {
    setLoading(true); setError(''); setProblems([]); setRawRows([]); setSelected(null);
    setDetRows([]); setDetTotal(0); setDetHasMore(false);
    const j = await API(`/auto-document/havaleh/ready/?${qs(1)}`);
    setLoading(false);
    if (j.ok) { setRawRows(j.data); setServerTotal(j.total||j.count||0); setServerHasMore(j.has_more||false); setCurrentPage(1); }
    else setError(j.msg);
  }, [qs]);

  /* ۲۰۰ ردیف بعدی */
  const loadMore = async () => {
    const nextPage = currentPage + 1;
    setLoadingMore(true);
    const j = await API(`/auto-document/havaleh/ready/?${qs(nextPage)}`);
    setLoadingMore(false);
    if (j.ok) {
      setRawRows(prev => [...prev, ...j.data]);
      setServerTotal(j.total||0); setServerHasMore(j.has_more||false); setCurrentPage(nextPage);
    }
  };

  useEffect(() => { load(); }, [load]);

  const sel = selected ? rawRows.find(r => r.havaleh_id === selected) : null;

  const detQs = (row, page) =>
    `havaleh_id=${row.havaleh_id}&financial_year=${row.financial_year||year}&page=${page}`;

  /* ریز ردیف انتخاب‌شده */
  const loadDetail = useCallback(async (row) => {
    if (!row) { setDetRows([]); setDetTotal(0); setDetHasMore(false); return; }
    setDetLoading(true); setDetRows([]);
    const j = await API(`/auto-document/havaleh/detail/?${detQs(row,1)}`);
    setDetLoading(false);
    if (j.ok) { setDetRows(j.data); setDetTotal(j.total||0); setDetHasMore(j.has_more||false); setDetPage(1); }
    else setError(j.msg);
  }, [year]);

  /* ۲۰۰ ریز بعدی */
  const loadDetailMore = async () => {
    if (!sel) return;
    const nextPage = detPage + 1;
    setDetLoadingMore(true);
    const j = await API(`/auto-document/havaleh/detail/?${detQs(sel,nextPage)}`);
    setDetLoadingMore(false);
    if (j.ok) { setDetRows(prev => [...prev, ...j.data]); setDetTotal(j.total||0); setDetHasMore(j.has_more||false); setDetPage(nextPage); }
  };

  /* اعتبارسنجی قبل از ثبت */
  const runValidate = async (row) => {
    setChecking(true); setProblems([]);
    const j = await API(`/auto-document/havaleh/validate/?havaleh_id=${row.havaleh_id}`);
    setChecking(false);
    if (j.ok) setProblems(j.problems||[]); else setError(j.msg);
  };

  /* ساخت سند */
  const createDoc = async () => {
    if (!sel) { setError('حواله‌ای انتخاب نشده'); return; }
    setSaving(true); setError('');
    const j = await API('/auto-document/havaleh/create/', {
      method:'POST',
      body: JSON.stringify({ financial_year:year, ready_document_no:si(readyNo),
                             havaleh_id:sel.havaleh_id, split_mode:splitMode }),
    });
    setSaving(false);
    if (j.ok) {
      const bal = j.balanced ? '' : ` ⚠ سند تراز نیست (بدهکار ${numFmt(j.sum_debit)} / بستانکار ${numFmt(j.sum_credit)})`;
      setToast(j.msg + bal); setTimeout(()=>setToast(''), 8000);
      if (j.warnings && j.warnings.length) setProblems(j.warnings.map(w=>({msg:w})));
      onAdded&&onAdded(); load();
    } else {
      setError(j.msg);
      if (j.problems) setProblems(j.problems);
    }
  };

  /* انتخاب/لغو انتخاب ردیف */
  const pickRow = row => {
    const isSel = selected === row.havaleh_id;
    if (isSel) { setSelected(null); setDetRows([]); setDetTotal(0); setDetHasMore(false); setProblems([]); }
    else { setSelected(row.havaleh_id); loadDetail(row); runValidate(row); }
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e=>e.stopPropagation()}>
        <div style={s.hdr}>
          <div>
            <div style={{fontSize:'15px',fontWeight:'700',color:'#fff'}}>🧾 تامین اعتبار (حواله)</div>
            <div style={{fontSize:'11px',color:'rgba(255,255,255,0.6)',marginTop:'2px'}}>
              تامین اعتبارهای ارسال‌شده به حسابداری بدون آرتیکل — سال مالی {toFa(year)}
            </div>
          </div>
          <button onClick={onClose} style={s.xBtn}>✕</button>
        </div>

        <div style={s.body}>
          {error && <div style={s.err}>⚠️ {error}</div>}

          {problems.length>0 && (
            <div style={blockers.length>0 ? s.err
              : {...s.err, background:'#fff8e1', border:'1px solid #f0d68a', color:'#7a5b00'}}>
              {problems.map((p,i)=>(
                <div key={i} style={{marginBottom:i<problems.length-1?'6px':0}}>
                  ⚠️ {p.msg}
                  {p.items && p.items.length>0 && (
                    <div style={{fontSize:'11px',color:'#8d3a3a',marginTop:'3px'}}>{p.items.join(' — ')}</div>
                  )}
                </div>
              ))}
            </div>
          )}
          {sel && !checking && problems.length===0 && (
            <div style={s.okBox}>✅ اعتبارسنجی حواله بدون ایراد است</div>
          )}

          <div style={{...s.card, background:'#fffdf5', border:'1.5px solid #f0e6c0'}}>
            <div style={{fontSize:'12px',fontWeight:'700',color:'#8d6e00',marginBottom:'8px'}}>🧾 سند مقصد</div>
            <div style={{display:'flex',gap:'14px',flexWrap:'wrap',alignItems:'flex-end'}}>
              <div style={s.fld}>
                <label style={s.lbl}>شماره سند مقصد</label>
                <input value={toFa(readyNo)} onChange={e=>setReadyNo(toEng(e.target.value).replace(/\D/g,'').slice(0,6))}
                  placeholder="خالی = سند جدید" style={{...s.inp,width:'150px'}} />
              </div>
              <div style={s.fld}>
                <label style={s.lbl}>تفکیک در اشخاص</label>
                <select value={splitMode} onChange={e=>setSplitMode(si(e.target.value))} style={{...s.inp,width:'190px'}}>
                  <option value={0}>بدون تفکیک اشخاص</option>
                  <option value={1}>با تفکیک اشخاص</option>
                  <option value={2}>تفکیک بجز حساب ۱۱۰</option>
                </select>
              </div>
              <div style={{fontSize:'11px',color:'#555',flex:1,minWidth:'200px'}}>⚠ تک‌انتخابی — هر بار فقط یک حواله</div>
            </div>
          </div>

          <ReadyFilters f={f}
            searchLabel="جستجو (ردیف تامین اعتبار / شماره حواله / شرح / قرارداد / پیمانکار)">
            <button onClick={load} disabled={loading} style={s.btnS}>{loading?'⏳...':'↺ به‌روزرسانی'}</button>
            <span style={{fontSize:'11px',color:'#888'}}>{toFa(shownCount)} از {toFa(serverTotal)}</span>
          </ReadyFilters>

          <div style={{maxHeight:'clamp(150px,30vh,340px)',flexShrink:0,overflow:'auto',WebkitOverflowScrolling:'touch',borderRadius:'8px',boxShadow:'0 1px 6px rgba(0,0,0,0.1)'}}>
            <table style={{width:'100%',borderCollapse:'collapse',direction:'rtl',fontSize:'11px',tableLayout:'fixed'}}>
              {/* سرستون‌ها */}
              <thead>
                <tr>
                  <TH idx={0}>سال مالی</TH>
                  <TH idx={1}>ردیف ت.اعتبار</TH>
                  <TH idx={2}>تاریخ ت.اعتبار</TH>
                  <TH idx={3}>شماره حواله</TH>
                  <TH idx={4}>تاریخ حواله</TH>
                  <TH idx={5}>نوع حساب</TH>
                  <TH idx={6}>نوع حواله</TH>
                  <TH idx={7} right>شرح</TH>
                  <TH idx={8} right>قرارداد</TH>
                  <TH idx={9} right>پیمانکار</TH>
                  <TH idx={10} red>مبلغ</TH>
                  <TH idx={11}>بیمه کارفرما</TH>
                  <TH idx={12}>مالیات بر ارزش افزوده</TH>
                  <TH idx={13}>تنخواه</TH>
                  <TH idx={14}>علی الحساب</TH>
                  <TH idx={15}>پیش پرداخت</TH>
                  <TH idx={16} red>جمع هزینه</TH>
                  <TH idx={17}>جمع کسورات</TH>
                  <TH idx={18}>ریز</TH>
                </tr>
              </thead>
              <tbody>
                {visibleRows.map((r,i)=>{
                  const isSel = selected === r.havaleh_id;
                  return (
                  <tr key={r.havaleh_id} onClick={()=>pickRow(r)}
                    style={{background:isSel?'#e8f5e9':i%2===0?'#fff':'#fafafa',cursor:'pointer'}}>
                    <td style={s.td}>{toFa(r.financial_year)}</td>
                    <td style={{...s.td,fontWeight:'700'}}>{toFa(r.havaleh_no)}</td>
                    <td style={{...s.td,fontFamily:'monospace',fontSize:'10px'}}>{r.havaleh_date||'—'}</td>
                    <td style={s.td}>{toFa(r.request_no)}</td>
                    <td style={{...s.td,fontFamily:'monospace',fontSize:'10px'}}>{r.request_date||'—'}</td>
                    <td style={{...s.td,fontSize:'10px',color:r.program_type===0?'#1565c0':'#4a148c'}}>{r.program_type_title}</td>
                    <td style={{...s.td,fontSize:'10px'}} title={r.havaleh_kind_title}>{r.havaleh_kind_title||'—'}</td>
                    <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={r.remark}>{r.remark||'—'}</td>
                    <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={r.contract_display}>{r.contract_display||'—'}</td>
                    <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={r.contractor_name}>{r.contractor_name||'—'}</td>
                    <td style={{...s.td,fontFamily:'monospace',fontWeight:'700',color:'#b71c1c'}}>{numFmt(r.sum_amount)}</td>
                    <td style={{...s.td,fontFamily:'monospace',color:'#1565c0'}}>{numFmt(r.sum_insure)}</td>
                    <td style={{...s.td,fontFamily:'monospace',color:'#e65100'}}>{numFmt(r.sum_added_tax)}</td>
                    <td style={{...s.td,fontFamily:'monospace',color:'#00695c'}}>{numFmt(r.sum_fund_pay)}</td>
                    <td style={{...s.td,fontFamily:'monospace',color:'#00695c'}}>{numFmt(r.sum_on_account)}</td>
                    <td style={{...s.td,fontFamily:'monospace',color:'#00695c'}}>{numFmt(r.sum_prepayment)}</td>
                    <td style={{...s.td,fontFamily:'monospace',fontWeight:'700',color:'#b71c1c'}}>{numFmt(r.sum_total_cost)}</td>
                    <td style={{...s.td,fontFamily:'monospace',color:'#4a148c'}}>{numFmt(r.sum_deduction)}</td>
                    <td style={s.td}>{toFa(r.item_count)}</td>
                  </tr>);})}
                {!loading && visibleRows.length===0 && (
                  <tr><td colSpan={19} style={{...s.td,padding:'24px',color:'#999'}}>📭 تامین اعتبار ثبت نشده ای وجود ندارد</td></tr>
                )}
              </tbody>
            </table>
          </div>

          <LoadMoreButton onClick={loadMore} loading={loadingMore} />

          {sel && (
            <>
              <div style={{display:'flex',alignItems:'center',gap:'8px',flexWrap:'wrap',flexShrink:0}}>
                <span style={{fontSize:'12px',fontWeight:'700',color:'#8d6e00'}}>
                  📋 ریز تراکنش‌های تامین اعتبار ردیف {toFa(sel.havaleh_no)}
                </span>
                <span style={{fontSize:'11px',color:'#888'}}>
                  {detLoading ? '⏳ در حال بارگذاری...' : `${toFa(detRows.length)} از ${toFa(detTotal)}`}
                </span>
              </div>

              <div style={{maxHeight:'clamp(140px,28vh,320px)',minHeight:'90px',flexShrink:0,overflow:'auto',WebkitOverflowScrolling:'touch',borderRadius:'8px',boxShadow:'0 1px 6px rgba(0,0,0,0.1)'}}>
                <table style={{width:'100%',borderCollapse:'collapse',direction:'rtl',fontSize:'11px',tableLayout:'fixed'}}>
                  {/* سرستون‌ها */}
                  <thead>
                    <tr>
                      <DTH idx={0} gold right>توضیح</DTH>
                      <DTH idx={1} gold right>گیرنده وجه</DTH>
                      <DTH idx={2} gold right>نام کارمند</DTH>
                      <DTH idx={3} gold right>منبع اعتبار</DTH>
                      <DTH idx={4} gold right>برنامه/طرح</DTH>
                      <DTH idx={5} gold right>پروژه/فعالیت</DTH>
                      <DTH idx={6} gold right>فصل</DTH>
                      <DTH idx={7} gold>مبلغ حواله</DTH>
                      <DTH idx={8} gold>بیمه تامین</DTH>
                      <DTH idx={9} gold>مالیات بر ارزش افزوده</DTH>
                      <DTH idx={10} gold>تنخواه گردان</DTH>
                      <DTH idx={11} gold>پیش پرداخت</DTH>
                      <DTH idx={12} gold>علی الحساب</DTH>
                      <DTH idx={13} gold>جمع هزینه</DTH>
                      <DTH idx={14} gold>تسویه تنخواه</DTH>
                      <DTH idx={15} gold>خالص</DTH>
                      <DTH idx={16} gold>کسورات</DTH>
                      <DTH idx={17} gold right>نوع سندخزانه</DTH>
                      <DTH idx={18} gold>شمول</DTH>
                    </tr>
                  </thead>
                  <tbody>
                    {detRows.map((g,i)=>(
                      <tr key={g.budget_transaction_id} style={{background:i%2===0?'#fffdf7':'#fff'}}>
                        <td style={{...s.td,textAlign:'right'}} title={g.remark}>{g.remark||'—'}</td>
                        <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={g.receiver_name}>{g.receiver_name||'—'}</td>
                        <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={g.people_name}>{g.people_name||'—'}</td>
                        <td style={{...s.td,textAlign:'right',fontSize:'10px',color:g.credit_type_warn?'#c62828':undefined}}
                            title={g.credit_display}>{g.credit_display||'—'}{g.source_type_warn?' ⚠':''}</td>
                        <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={g.program_display}>{g.program_display||'—'}</td>
                        <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={g.project_display}>{g.project_display||'—'}</td>
                        <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={g.hazineh_display}>{g.hazineh_display||'—'}</td>
                        <td style={{...s.td,fontFamily:'monospace',fontWeight:'700',color:'#b71c1c'}}>{numFmt(g.havaleh_amount)}</td>
                        <td style={{...s.td,fontFamily:'monospace',color:'#1565c0'}}>{numFmt(g.tamin_insure)}</td>
                        <td style={{...s.td,fontFamily:'monospace',color:'#e65100'}}>{numFmt(g.added_tax)}</td>
                        <td style={{...s.td,fontFamily:'monospace',color:'#00695c'}}>{numFmt(g.fund_pay)}</td>
                        <td style={{...s.td,fontFamily:'monospace',color:'#00695c'}}>{numFmt(g.prepayment)}</td>
                        <td style={{...s.td,fontFamily:'monospace',color:'#00695c'}}>{numFmt(g.on_account)}</td>
                        <td style={{...s.td,fontFamily:'monospace',fontWeight:'700',color:'#b71c1c'}}>{numFmt(g.total_cost)}</td>
                        <td style={{...s.td,fontFamily:'monospace',color:'#795548'}}>{numFmt(g.back_fund_pay)}</td>
                        <td style={{...s.td,fontFamily:'monospace',fontWeight:'700',color:'#1b5e20'}}>{numFmt(g.net_amount)}</td>
                        <td style={{...s.td,fontFamily:'monospace',color:'#4a148c'}}>{numFmt(g.deduction)}</td>
                        <td style={{...s.td,textAlign:'right',fontSize:'10px'}} title={g.treasury_display}>{g.treasury_display||'—'}</td>
                        <td style={{...s.td,fontSize:'10px'}}>{g.shomool_title||'—'}</td>
                      </tr>
                    ))}
                    {!detLoading && detRows.length===0 && (
                      <tr><td colSpan={19} style={{...s.td,padding:'18px',color:'#999'}}>📭 ریز تراکنشی ثبت نشده است</td></tr>
                    )}
                  </tbody>
                </table>
              </div>

              {detHasMore && (
                <div style={{textAlign:'center',padding:'10px 0',flexShrink:0}}>
                  <button onClick={loadDetailMore} disabled={detLoadingMore}
                    style={{padding:'9px 36px',background:detLoadingMore?'#ccc':'linear-gradient(135deg,#0d2137,#1a2f50)',
                      color:'#fff',border:'none',borderRadius:'8px',cursor:detLoadingMore?'default':'pointer',
                      fontFamily:'inherit',fontSize:'13px',fontWeight:'700'}}>
                    {detLoadingMore ? '⏳ در حال بارگذاری...'
                      : `▼ ۲۰۰ ریز تراکنش بعدی (${toFa(detTotal-detRows.length)} باقی‌مانده)`}
                  </button>
                </div>
              )}
            </>
          )}

          <div style={{display:'flex',alignItems:'center',gap:'8px',flexWrap:'wrap',flexShrink:0}}>
            {sel && <>
              <span style={s.badge('#1a2f50')}>ردیف {toFa(sel.havaleh_no)}</span>
              <span style={s.badge(sel.program_type===0?'#1565c0':'#4a148c')}>{sel.program_type_title}</span>
              <span style={s.badge('#8d6e00')}>{sel.havaleh_kind_title}</span>
              <span style={s.badge('#b71c1c')}>جمع هزینه: {numFmt(sel.sum_total_cost)}</span>
              <span style={s.badge('#4a148c')}>کسورات: {numFmt(sel.sum_deduction)}</span>
              <span style={s.badge('#555')}>ریز: {toFa(sel.item_count)}</span>
            </>}
            <span
              onClick={()=>{
                if (saving) return;
                if (!sel) { setToast('⚠️ ابتدا یک ردیف حواله را انتخاب کنید'); setTimeout(()=>setToast(''),6000); return; }
                if (blockers.length>0) {
                  const reason = blockers.map(p=>p.msg).filter(Boolean).join('  |  ');
                  setToast('⛔ امکان ساخت سند نیست: ' + (reason || 'ایراد در اطلاعات حواله'));
                  setTimeout(()=>setToast(''),8000);
                  return;
                }
              }}
              style={{marginRight:'auto',display:'inline-flex'}}>
              <button onClick={createDoc} disabled={saving||!sel||blockers.length>0}
                style={{...s.btnP,opacity:(saving||!sel||blockers.length>0)?0.4:1,
                  pointerEvents:(saving||!sel||blockers.length>0)?'none':'auto'}}>
                {saving?'⏳ در حال ثبت آرتیکل‌ها...':(si(readyNo)===0?'💾 ساخت سند تامین اعتبار':'💾 افزودن به سند')}
              </button>
            </span>
          </div>
        </div>

        {toast && <div style={{position:'absolute',bottom:'14px',right:'14px',background:'#1b5e20',
          color:'#fff',padding:'10px 20px',borderRadius:'8px',fontSize:'13px',fontWeight:'600',zIndex:10,
          maxWidth:'60%'}}>{toast}</div>}
      </div>
    </div>
  );
}

/* استایل‌ها */
const s = {
  overlay:   {position:'fixed',inset:0,background:'rgba(0,0,0,0.65)',zIndex:3000,display:'flex',alignItems:'center',justifyContent:'center',padding:'12px'},
  modal:     {background:'#f0f2f7',borderRadius:'14px',width:'100%',maxWidth:'1500px',height:'96vh',maxHeight:'96vh',display:'flex',flexDirection:'column',boxShadow:'0 24px 64px rgba(0,0,0,0.5)',overflow:'hidden',position:'relative'},
  hdr:       {display:'flex',justifyContent:'space-between',alignItems:'flex-start',padding:'14px 18px',background:'linear-gradient(135deg,#0a1628,#1565c0)',flexShrink:0},
  xBtn:      {background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',color:'#fff',width:'28px',height:'28px',borderRadius:'50%',cursor:'pointer',fontSize:'12px',display:'flex',alignItems:'center',justifyContent:'center'},
  body:      {flex:1,overflowY:'auto',padding:'14px',display:'flex',flexDirection:'column',gap:'10px'},
  err:       {background:'#fff3f3',border:'1px solid #ffcdd2',borderRadius:'7px',padding:'8px 12px',color:'#c62828',fontSize:'12px'},
  okBox:     {background:'#f1f8f2',border:'1px solid #c8e6c9',borderRadius:'7px',padding:'8px 12px',color:'#1b5e20',fontSize:'12px'},
  phase:     {background:'#fff8e1',border:'1px solid #ffe082',borderRadius:'7px',padding:'8px 12px',color:'#8d6e00',fontSize:'12px',lineHeight:'1.8'},
  card:      {background:'#fff',borderRadius:'10px',padding:'14px',boxShadow:'0 1px 4px rgba(0,0,0,0.08)'},
  fld:       {display:'flex',flexDirection:'column',gap:'3px'},
  lbl:       {fontSize:'11px',fontWeight:'600',color:'#555'},
  inp:       {padding:'7px 10px',border:'1.5px solid #e0e0e0',borderRadius:'7px',fontSize:'12px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',textAlign:'right',boxSizing:'border-box'},
  td:        {padding:'5px 8px',fontSize:'11px',textAlign:'center',borderBottom:'1px solid #f0f0f0',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},
  btnP:      {padding:'9px 20px',background:'linear-gradient(135deg,#1565c0,#1976d2)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  btnS:      {padding:'8px 14px',background:'#e0e0e0',color:'#333',border:'none',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'12px'},
  badge:     bg => ({padding:'4px 10px',background:bg,color:'#fff',borderRadius:'16px',fontSize:'11px',fontWeight:'700'}),
};